import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.token) localStorage.setItem("vc_token", data.token);
        if (data.user) setUser(data.user);
        navigate("/feed", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[#68706B]">
      Signing you in…
    </div>
  );
}
